function isDifferenceLessThan24Hours(date1: Date, date2: Date): boolean {
    const differenceInMilliseconds = Math.abs(date2.getTime() - date1.getTime());
    const differenceInHours = differenceInMilliseconds / (1000 * 60 * 60);
    return differenceInHours < 24;
}

export default isDifferenceLessThan24Hours;
